import { usePartner } from '@/features/auth'
import { useReferrals } from '../hooks'
import { referralsTexts } from '../referrals.texts'
import { ReferralCodeCard } from '../components'

const LoadingSkeleton = () => (
  <div className="flex flex-col gap-6" aria-busy="true">
    {[0, 1].map((i) => (
      <div
        key={i}
        className="h-48 rounded-lg bg-background border border-border-light animate-skeleton-pulse"
      />
    ))}
  </div>
)

export const DashboardPage = () => {
  const { partner } = usePartner()
  const { payload, isLoading, error, mutate } = useReferrals()
  const texts = referralsTexts.dashboard

  const partnerName = payload?.partner.name ?? partner?.name ?? ''

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          {texts.greeting(partnerName)}
        </h1>
        <p className="text-sm text-muted mt-1">{texts.subtitle}</p>
      </div>

      {isLoading && <LoadingSkeleton />}

      {!isLoading && error && (
        <div className="bg-background rounded-lg border border-border-light p-6 text-center">
          <p className="text-sm text-error-text" role="alert">
            {texts.loadError}
          </p>
          <button
            type="button"
            onClick={() => mutate()}
            className="mt-4 px-4 py-2 rounded-md border border-border text-sm font-medium text-foreground hover:bg-background-secondary transition-colors cursor-pointer"
          >
            {texts.retry}
          </button>
        </div>
      )}

      {!isLoading && !error && payload && (
        <>
          {payload.codes.length === 0 ? (
            <div className="bg-background rounded-lg border border-border-light p-6">
              <p className="text-sm text-muted text-center">{texts.noCodes}</p>
            </div>
          ) : (
            payload.codes.map((code) => <ReferralCodeCard key={code.id} code={code} />)
          )}
        </>
      )}
    </div>
  )
}
